import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { Link } from "react-router-dom";
import RejectModal from "../jobListing/RejectModal";
import ApprovedModal from "../jobListing/ApprovedModal";
import {
    rejectApplicant,
    approveApplicant
} from "../../../services/employerJobListing";
import { getRecords } from "../../../services/employerApplicant";
import {create } from "../../../services/message";

class List extends Component {
    state = {
        delete: false,
        item: {},
        showApplicantModal: false,
        showApproveModal: false,
        showRejectModal: false,
        id: 0
    };
    toggleApproveModal = id => {
        this.setState({
            id: id,
            showApproveModal: !this.state.showApproveModal
        });
    };
    toggleRejectModal = id => {
        this.setState({ id: id, showRejectModal: !this.state.showRejectModal });
    };
    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    toggleApplicantModal = () => {
        this.setState({ showApplicantModal: !this.state.showApplicantModal });
    };
    capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || "";

    rejectApplicant = () => {
        let _this= this;
        return rejectApplicant(this.state.id).then(response => {
            this.setState({
                            showApproveModal: false,
                            showRejectModal: false,
                            items: response.data,
                            meta: response.meta,
                            loading: false
                        });
            _this.props.rerender();
        });
    };

    approveApplicant = () => {
        let _this= this;
        return approveApplicant(this.state.id).then(response => {
            this.setState({
                showApproveModal: false,
                showRejectModal: false,
                items: response.data,
                meta: response.meta,
                loading: false
            });
            _this.props.rerender();
        });
    };
    createMessage = (userid , jobId) =>{
        create(userid , jobId )
        .then(response => {
             this.props.history.push(
                "/" + this.context.state.user.type + "/messages/" + response.data.key
            );
        })

    }

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.index + 1}</td>
                    <td>
                        <Link
                            to={`/employer/jobListing/workSpace/${this.props.item.link}`}
                        >
                            {this.props.item.user.name}
                        </Link>
                    </td>
                    <td className="large" onClick={this.toggleApplicantModal}>
                        {this.props.item.user.email}
                    </td>
                    {/* <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td> */}
                    <td><a
                                    target="_Blank"
                                    rel="noopener noreferrer"
                                    href={`/pw/` + this.props.item.user.url}
                                    type="button"
                                    className="btn btn-success btn-sm"
                                >
                                    View Profile
                                </a>
                                </td>
                    
                    
                </tr>
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/employer/writers/List.js